unit unit_GetPhoto;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Devices, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.WebCtrls, strutils;

type
  TGetPhoto = class(TForm)
    WebCamera1: TCamera;
    Container2: THTMLContainer;
    Container1: THTMLContainer;
    btnCameraAus: TButton;
    btnCameraStart: TButton;
    Container3: THTMLContainer;
    MyImage: TImageControl;
    dsDateien: TXDataWebDataSet;
    edtBetreff: TEdit;
    WebFilePicker1: TFilePicker;
    btnzurueck: TButton;
    dsDateienID: TIntegerField;
    dsDateienDatumUhrzeit: TDateTimeField;
    dsDateienDateiMime: TStringField;
    dsDateienDateiName: TStringField;
    dsDateienDateiGroesse: TIntegerField;
    dsDateienDateiInhaltText: TStringField;
    dsDateienDateiInhaltThumb: TStringField;
    dsDateienProtokoll: TStringField;
    dsDateienDateiBetreff: TStringField;
    dsDateienKundennummer: TStringField;
    dsDateienNummerkomplett: TStringField;
    dsDateienObjektReferenz: TStringField;
    dsDateienFahrzeugID: TIntegerField;
    lblBetreff: TLabel;
    btnSpeichern: TButton;
    lblCamera: TLabel;
    Container4: THTMLContainer;
    dsDateienAuslagerungsdatei: TStringField;
    procedure WebCamera1CameraDevicesInitialized(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnCameraAusClick(Sender: TObject);
    procedure btnCameraStartClick(Sender: TObject);
    procedure WebCamera1Click(Sender: TObject);
    procedure dsDateienAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
    procedure WebFilePicker1Change(Sender: TObject);
    procedure WebFilePicker1GetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure btnSpeichernClick(Sender: TObject);
    procedure dsDateienAfterPost(DataSet: TDataSet);
    procedure dsDateienAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    PhotoMerkerArt:string;
    PhotoMerkerNummerkomplett:string;
    PhotoMerkerObjektreferenz:string;
    PhotoMerkerFahrzeugID:string;
    PhotoMerkerKundennummer:string;
    PhotoMerkerName:string;
    PhotoHeadlineText:string;
    PhotoEinzelDateiID:string;
    PhotoFunktion:string;
    PhotoPNG:string;
    file1base64str1:string;
  protected procedure LoadDFMValues; override; end;

var
  GetPhoto: TGetPhoto;

implementation
  uses unit1,unit2;
{$R *.dfm}


procedure TGetPhoto.btnSpeichernClick(Sender: TObject);
var
  myfileextension:string;
  myfilewithoutext:string;
begin
  if edtBetreff.Text='' then
  begin
    showmessage('Bitte Betreff eintragen');
    exit;
  end;
  if file1base64str1='' then
  begin
    showmessage('Es gibt nichts zu speichern');
    exit;
  end;

  dsDateien.Append;
  dsDateienDatumUhrzeit.AsDateTime:=date+time;
  dsDateienDateiBetreff.AsString:=edtBetreff.Text;
  if PhotoFunktion='Foto' then
  begin
    dsDateienDateiMime.AsString:='image/png';
    dsDateienDateiGroesse.AsInteger:=length(file1base64str1);
    dsDateienDateiName.AsString:=form1.stripsonderzeichen(leftstr(edtbetreff.Text,50))+'.png';
  end
  else
  begin
    dsDateienDateiMime.AsString:=WebFilePicker1.Files.Items[0].MimeType;
    dsDateienDateiGroesse.AsInteger:=WebFilePicker1.Files.Items[0].Size;
    myfilewithoutext:=WebFilePicker1.Files.Items[0].Name;
    myfileextension:=ExtractFileExt(WebFilePicker1.Files.Items[0].Name);
    myfilewithoutext:=replacestr(myfilewithoutext,myfileextension,'');
    myfilewithoutext:=form1.StripSonderzeichen(myfilewithoutext);
    dsDateienDateiName.AsString:=myfilewithoutext+myfileextension;
  end;
  dsDateienDateiInhaltText.AsString:=file1base64str1;
  dsDateienKundennummer.AsString:=PhotoMerkerKundennummer;
  dsDateienNummerkomplett.AsString:=PhotoMerkerNummerkomplett;
  dsDateienObjektReferenz.AsString:=PhotoMerkerObjektreferenz;
  dsDateienFahrzeugID.AsString:=PhotoMerkerFahrzeugID;
  dsdateien.Post;
end;

procedure TGetPhoto.btnCameraStartClick(Sender: TObject);
begin
  if WebCamera1.CameraDevices.Count<1 then
  begin
    lblCamera.Caption:='Keine Camera vorhanden';
    btnSpeichern.Enabled:=false;
    exit;
  end
  else
  begin
    lblCamera.Caption:='';
  end;
  WebCamera1.Visible:=true;
  WebCamera1.Start;

end;

procedure TGetPhoto.btnzurueckClick(Sender: TObject);
begin
  self.Close;
end;

procedure TGetPhoto.dsDateienAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  lblBetreff.Caption:='ist gespeichert';
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    lblBetreff.Caption:='ist gespeichert';
    self.close;
  end;
  self.close;
end;

procedure TGetPhoto.dsDateienAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  myheadline:string;
begin
  if PhotoFunktion='Foto' then myheadline:='Foto hinzufügen' else myheadline:='Datei hinzufügen';
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>'+myheadline+'</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.parentelement:=myelement;
  btnspeichern.parentelement:=myelement;
  btncameraStart.ParentElement:=myelement;
  btncameraAus.ParentElement:=myelement;
  myimage.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  Container2.HTML.Text:='';
  WebFilePicker1.ParentElement:=myelement;
  lblBetreff.parentelement:=myelement;
  edtbetreff.ParentElement:=myelement;

  Container3.html.text:='';
  myelement:=container3.elementhandle;
  lblcamera.parentelement:=myelement;

  Container4.html.text:='';
  myelement:=container4.elementhandle;
  webcamera1.ParentElement:=myelement;


  if PhotoFunktion='Foto' then
  begin
    WebFilePicker1.visible:=false;
    btnCameraStart.visible:=true;
    btnCameraAus.visible:=true;
    lblcamera.visible:=true;
    btncamerastartClick(nil);
  end
  else
  begin
    WebFilePicker1.visible:=true;
    webcamera1.visible:=false;
    btnCameraStart.visible:=false;
    btnCameraAus.visible:=false;
    lblcamera.visible:=false;
  end;
end;

procedure TGetPhoto.dsDateienAfterPost(DataSet: TDataSet);
begin
  lblBetreff.Caption:='wird gespeichert';
  dsDateien.applyupdates;
end;

procedure TGetPhoto.btnCameraAusClick(Sender: TObject);
begin
  webcamera1.Stop;
  webcamera1.Visible:=false;
  btnCamerastart.enabled:=true;
  btnCameraAus.Enabled:=false;
end;

procedure TGetPhoto.WebCamera1CameraDevicesInitialized(Sender: TObject);
begin
  btnCamerastart.enabled:=false;
  btnCameraAus.Enabled:=true;
  btnSpeichern.Enabled:=true;
end;

procedure TGetPhoto.WebCamera1Click(Sender: TObject);
begin
  file1base64str1:=WebCamera1.SnapShotAsBase64;
  MyImage.URL := WebCamera1.SnapShotAsBase64;
  btnCameraAusClick(sender);
  edtbetreff.SetFocus;
end;

procedure TGetPhoto.WebFilePicker1Change(Sender: TObject);
begin
  file1base64str1:='';
  if WebFilePicker1.Files.Count>0 then
  begin
    if WebFilePicker1.Files.Items[0].Size<5242880 then
    begin
      webfilepicker1.Files.Items[0].GetFileAsBase64;
    end
    else
    begin
      showmessage('Datei ist zu groß, bitte andere Datei wählen');
    end;
  end;
end;

procedure TGetPhoto.WebFilePicker1GetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  file1base64str1:= 'data:' + WebFilePicker1.Files.Items[0].MimeType + ';base64,' + ABase64;
  if Webfilepicker1.Files.Items[0].MimeType='image/png' then myimage.URL := file1base64str1;
  if Webfilepicker1.Files.Items[0].MimeType='image/jpeg' then myimage.URL := file1base64str1;
  if Webfilepicker1.Files.Items[0].MimeType='image/bmp' then myimage.URL := file1base64str1;
end;

procedure TGetPhoto.WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
begin
  dsDateien.Close;
end;

procedure TGetPhoto.WebFormShow(Sender: TObject);
begin
  dsdateien.Load;
end;
procedure TGetPhoto.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MyImage := TImageControl.Create(Self);
  lblBetreff := TLabel.Create(Self);
  lblCamera := TLabel.Create(Self);
  WebCamera1 := TCamera.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  btnCameraAus := TButton.Create(Self);
  btnCameraStart := TButton.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  edtBetreff := TEdit.Create(Self);
  WebFilePicker1 := TFilePicker.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnSpeichern := TButton.Create(Self);
  Container4 := THTMLContainer.Create(Self);
  dsDateien := TXDataWebDataSet.Create(Self);
  dsDateienID := TIntegerField.Create(Self);
  dsDateienDatumUhrzeit := TDateTimeField.Create(Self);
  dsDateienDateiMime := TStringField.Create(Self);
  dsDateienDateiName := TStringField.Create(Self);
  dsDateienDateiGroesse := TIntegerField.Create(Self);
  dsDateienDateiInhaltText := TStringField.Create(Self);
  dsDateienDateiInhaltThumb := TStringField.Create(Self);
  dsDateienProtokoll := TStringField.Create(Self);
  dsDateienDateiBetreff := TStringField.Create(Self);
  dsDateienKundennummer := TStringField.Create(Self);
  dsDateienNummerkomplett := TStringField.Create(Self);
  dsDateienObjektReferenz := TStringField.Create(Self);
  dsDateienFahrzeugID := TIntegerField.Create(Self);
  dsDateienAuslagerungsdatei := TStringField.Create(Self);

  MyImage.BeforeLoadDFMValues;
  lblBetreff.BeforeLoadDFMValues;
  lblCamera.BeforeLoadDFMValues;
  WebCamera1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  btnCameraAus.BeforeLoadDFMValues;
  btnCameraStart.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  edtBetreff.BeforeLoadDFMValues;
  WebFilePicker1.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnSpeichern.BeforeLoadDFMValues;
  Container4.BeforeLoadDFMValues;
  dsDateien.BeforeLoadDFMValues;
  dsDateienID.BeforeLoadDFMValues;
  dsDateienDatumUhrzeit.BeforeLoadDFMValues;
  dsDateienDateiMime.BeforeLoadDFMValues;
  dsDateienDateiName.BeforeLoadDFMValues;
  dsDateienDateiGroesse.BeforeLoadDFMValues;
  dsDateienDateiInhaltText.BeforeLoadDFMValues;
  dsDateienDateiInhaltThumb.BeforeLoadDFMValues;
  dsDateienProtokoll.BeforeLoadDFMValues;
  dsDateienDateiBetreff.BeforeLoadDFMValues;
  dsDateienKundennummer.BeforeLoadDFMValues;
  dsDateienNummerkomplett.BeforeLoadDFMValues;
  dsDateienObjektReferenz.BeforeLoadDFMValues;
  dsDateienFahrzeugID.BeforeLoadDFMValues;
  dsDateienAuslagerungsdatei.BeforeLoadDFMValues;
  try
    Name := 'GetPhoto';
    Top := 1;
    Width := 175;
    Height := 614;
    Caption := 'GetPhoto';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Arial';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCloseQuery', 'WebFormCloseQuery');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    MyImage.SetParentComponent(Self);
    MyImage.Name := 'MyImage';
    MyImage.Left := 8;
    MyImage.Top := 360;
    MyImage.Width := 145;
    MyImage.Height := 94;
    MyImage.WidthStyle := ssAuto;
    MyImage.HeightPercent := 100.000000000000000000;
    MyImage.WidthPercent := 100.000000000000000000;
    MyImage.ChildOrder := 8;
    MyImage.ElementFont := efCSS;
    lblBetreff.SetParentComponent(Self);
    lblBetreff.Name := 'lblBetreff';
    lblBetreff.Left := 20;
    lblBetreff.Top := 472;
    lblBetreff.Width := 147;
    lblBetreff.Height := 14;
    lblBetreff.Caption := 'Bitte geben Sie den Betreff ein';
    lblBetreff.ChildOrder := 5;
    lblBetreff.ElementClassName := 'h6 m-2';
    lblBetreff.ElementFont := efCSS;
    lblBetreff.ElementPosition := epIgnore;
    lblBetreff.HeightStyle := ssAuto;
    lblBetreff.HeightPercent := 100.000000000000000000;
    lblBetreff.WidthStyle := ssPercent;
    lblBetreff.WidthPercent := 80.000000000000000000;
    lblCamera.SetParentComponent(Self);
    lblCamera.Name := 'lblCamera';
    lblCamera.Left := 24;
    lblCamera.Top := 456;
    lblCamera.Width := 47;
    lblCamera.Height := 14;
    lblCamera.Caption := 'lblCamera';
    lblCamera.ElementClassName := 'h5 m-2';
    lblCamera.ElementFont := efCSS;
    lblCamera.ElementPosition := epIgnore;
    lblCamera.HeightStyle := ssAuto;
    lblCamera.HeightPercent := 100.000000000000000000;
    lblCamera.WidthStyle := ssAuto;
    lblCamera.WidthPercent := 100.000000000000000000;
    WebCamera1.SetParentComponent(Self);
    WebCamera1.Name := 'WebCamera1';
    WebCamera1.AlignWithMargins := True;
    WebCamera1.Left := 0;
    WebCamera1.Top := 222;
    WebCamera1.Width := 169;
    WebCamera1.Height := 118;
    WebCamera1.HeightStyle := ssAuto;
    WebCamera1.WidthStyle := ssPercent;
    WebCamera1.WidthPercent := 95.000000000000000000;
    WebCamera1.BaseFormat := cbfPNG;
    WebCamera1.CameraType := ctRear;
    SetEvent(WebCamera1, Self, 'OnCameraDevicesInitialized', 'WebCamera1CameraDevicesInitialized');
    SetEvent(WebCamera1, Self, 'OnClick', 'WebCamera1Click');
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-column m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    btnCameraAus.SetParentComponent(Self);
    btnCameraAus.Name := 'btnCameraAus';
    btnCameraAus.Left := 0;
    btnCameraAus.Top := 160;
    btnCameraAus.Width := 96;
    btnCameraAus.Height := 25;
    btnCameraAus.Caption := 'CAM aus';
    btnCameraAus.ChildOrder := 3;
    btnCameraAus.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnCameraAus.ElementFont := efCSS;
    btnCameraAus.ElementPosition := epIgnore;
    btnCameraAus.HeightStyle := ssAuto;
    btnCameraAus.HeightPercent := 100.000000000000000000;
    btnCameraAus.WidthStyle := ssAuto;
    btnCameraAus.WidthPercent := 100.000000000000000000;
    SetEvent(btnCameraAus, Self, 'OnClick', 'btnCameraAusClick');
    btnCameraStart.SetParentComponent(Self);
    btnCameraStart.Name := 'btnCameraStart';
    btnCameraStart.Left := 0;
    btnCameraStart.Top := 191;
    btnCameraStart.Width := 96;
    btnCameraStart.Height := 25;
    btnCameraStart.Caption := 'CAM an';
    btnCameraStart.ChildOrder := 3;
    btnCameraStart.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnCameraStart.ElementFont := efCSS;
    btnCameraStart.ElementPosition := epIgnore;
    btnCameraStart.HeightStyle := ssAuto;
    btnCameraStart.HeightPercent := 100.000000000000000000;
    btnCameraStart.WidthStyle := ssAuto;
    btnCameraStart.WidthPercent := 100.000000000000000000;
    SetEvent(btnCameraStart, Self, 'OnClick', 'btnCameraStartClick');
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 3;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    edtBetreff.SetParentComponent(Self);
    edtBetreff.Name := 'edtBetreff';
    edtBetreff.Left := 16;
    edtBetreff.Top := 536;
    edtBetreff.Width := 121;
    edtBetreff.Height := 22;
    edtBetreff.ChildOrder := 6;
    edtBetreff.ElementClassName := 'form-control m-1';
    edtBetreff.ElementFont := efCSS;
    edtBetreff.ElementPosition := epIgnore;
    edtBetreff.HeightStyle := ssAuto;
    edtBetreff.HeightPercent := 100.000000000000000000;
    edtBetreff.TextHint := 'Geben Sie hier einen Betreff f'#252'r die Datei/das Foto ein';
    edtBetreff.WidthStyle := ssPercent;
    edtBetreff.WidthPercent := 80.000000000000000000;
    WebFilePicker1.SetParentComponent(Self);
    WebFilePicker1.Name := 'WebFilePicker1';
    WebFilePicker1.Left := 8;
    WebFilePicker1.Top := 564;
    WebFilePicker1.Width := 121;
    WebFilePicker1.Height := 19;
    WebFilePicker1.ElementClassName := 'form-control m-1';
    WebFilePicker1.HeightStyle := ssAuto;
    WebFilePicker1.WidthStyle := ssPercent;
    WebFilePicker1.WidthPercent := 80.000000000000000000;
    WebFilePicker1.Accept := '.jpg,.jpeg,.png,.txt,.pdf,.zip';
    WebFilePicker1.ChildOrder := 7;
    WebFilePicker1.ElementFont := efCSS;
    WebFilePicker1.ElementPosition := epIgnore;
    SetEvent(WebFilePicker1, Self, 'OnChange', 'WebFilePicker1Change');
    SetEvent(WebFilePicker1, Self, 'OnGetFileAsBase64', 'WebFilePicker1GetFileAsBase64');
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 8;
    btnzurueck.Top := 141;
    btnzurueck.Width := 110;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnSpeichern.SetParentComponent(Self);
    btnSpeichern.Name := 'btnSpeichern';
    btnSpeichern.Left := 27;
    btnSpeichern.Top := 581;
    btnSpeichern.Width := 110;
    btnSpeichern.Height := 25;
    btnSpeichern.Caption := 'speichern';
    btnSpeichern.ChildOrder := 4;
    btnSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnSpeichern.ElementFont := efCSS;
    btnSpeichern.ElementPosition := epIgnore;
    btnSpeichern.HeightStyle := ssAuto;
    btnSpeichern.HeightPercent := 100.000000000000000000;
    btnSpeichern.WidthStyle := ssAuto;
    btnSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnSpeichern, Self, 'OnClick', 'btnSpeichernClick');
    Container4.SetParentComponent(Self);
    Container4.Name := 'Container4';
    Container4.Left := -2;
    Container4.Top := 141;
    Container4.Width := 169;
    Container4.Height := 41;
    Container4.ElementClassName := 'd-flex m-1';
    Container4.HeightStyle := ssAuto;
    Container4.WidthStyle := ssAuto;
    Container4.ChildOrder := 4;
    Container4.ElementFont := efCSS;
    Container4.ElementPosition := epIgnore;
    dsDateien.SetParentComponent(Self);
    dsDateien.Name := 'dsDateien';
    dsDateien.AfterApplyUpdates := dsDateienAfterApplyUpdates;
    dsDateien.AfterOpen := dsDateienAfterOpen;
    dsDateien.AfterPost := dsDateienAfterPost;
    dsDateien.EntitySetName := 'DokumenteDateien';
    dsDateien.Connection := DM2.XDataWebConnection1;
    dsDateien.QueryTop := 1;
    dsDateien.Left := 60;
    dsDateien.Top := 480;
    dsDateienID.SetParentComponent(dsDateien);
    dsDateienID.Name := 'dsDateienID';
    dsDateienID.FieldName := 'ID';
    dsDateienDatumUhrzeit.SetParentComponent(dsDateien);
    dsDateienDatumUhrzeit.Name := 'dsDateienDatumUhrzeit';
    dsDateienDatumUhrzeit.FieldName := 'DatumUhrzeit';
    dsDateienDatumUhrzeit.Required := True;
    dsDateienDateiMime.SetParentComponent(dsDateien);
    dsDateienDateiMime.Name := 'dsDateienDateiMime';
    dsDateienDateiMime.FieldName := 'DateiMime';
    dsDateienDateiMime.Size := 50;
    dsDateienDateiName.SetParentComponent(dsDateien);
    dsDateienDateiName.Name := 'dsDateienDateiName';
    dsDateienDateiName.FieldName := 'DateiName';
    dsDateienDateiName.Size := 255;
    dsDateienDateiGroesse.SetParentComponent(dsDateien);
    dsDateienDateiGroesse.Name := 'dsDateienDateiGroesse';
    dsDateienDateiGroesse.FieldName := 'DateiGroesse';
    dsDateienDateiInhaltText.SetParentComponent(dsDateien);
    dsDateienDateiInhaltText.Name := 'dsDateienDateiInhaltText';
    dsDateienDateiInhaltText.FieldName := 'DateiInhaltText';
    dsDateienDateiInhaltText.Size := 255;
    dsDateienDateiInhaltThumb.SetParentComponent(dsDateien);
    dsDateienDateiInhaltThumb.Name := 'dsDateienDateiInhaltThumb';
    dsDateienDateiInhaltThumb.FieldName := 'DateiInhaltThumb';
    dsDateienDateiInhaltThumb.Size := 255;
    dsDateienProtokoll.SetParentComponent(dsDateien);
    dsDateienProtokoll.Name := 'dsDateienProtokoll';
    dsDateienProtokoll.FieldName := 'Protokoll';
    dsDateienProtokoll.Size := 255;
    dsDateienDateiBetreff.SetParentComponent(dsDateien);
    dsDateienDateiBetreff.Name := 'dsDateienDateiBetreff';
    dsDateienDateiBetreff.FieldName := 'DateiBetreff';
    dsDateienDateiBetreff.Size := 50;
    dsDateienKundennummer.SetParentComponent(dsDateien);
    dsDateienKundennummer.Name := 'dsDateienKundennummer';
    dsDateienKundennummer.FieldName := 'Kundennummer';
    dsDateienKundennummer.Size := 13;
    dsDateienNummerkomplett.SetParentComponent(dsDateien);
    dsDateienNummerkomplett.Name := 'dsDateienNummerkomplett';
    dsDateienNummerkomplett.FieldName := 'Nummerkomplett';
    dsDateienNummerkomplett.Size := 10;
    dsDateienObjektReferenz.SetParentComponent(dsDateien);
    dsDateienObjektReferenz.Name := 'dsDateienObjektReferenz';
    dsDateienObjektReferenz.FieldName := 'ObjektReferenz';
    dsDateienObjektReferenz.Size := 13;
    dsDateienFahrzeugID.SetParentComponent(dsDateien);
    dsDateienFahrzeugID.Name := 'dsDateienFahrzeugID';
    dsDateienFahrzeugID.FieldName := 'FahrzeugID';
    dsDateienAuslagerungsdatei.SetParentComponent(dsDateien);
    dsDateienAuslagerungsdatei.Name := 'dsDateienAuslagerungsdatei';
    dsDateienAuslagerungsdatei.FieldName := 'Auslagerungsdatei';
  finally
    MyImage.AfterLoadDFMValues;
    lblBetreff.AfterLoadDFMValues;
    lblCamera.AfterLoadDFMValues;
    WebCamera1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    btnCameraAus.AfterLoadDFMValues;
    btnCameraStart.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    edtBetreff.AfterLoadDFMValues;
    WebFilePicker1.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnSpeichern.AfterLoadDFMValues;
    Container4.AfterLoadDFMValues;
    dsDateien.AfterLoadDFMValues;
    dsDateienID.AfterLoadDFMValues;
    dsDateienDatumUhrzeit.AfterLoadDFMValues;
    dsDateienDateiMime.AfterLoadDFMValues;
    dsDateienDateiName.AfterLoadDFMValues;
    dsDateienDateiGroesse.AfterLoadDFMValues;
    dsDateienDateiInhaltText.AfterLoadDFMValues;
    dsDateienDateiInhaltThumb.AfterLoadDFMValues;
    dsDateienProtokoll.AfterLoadDFMValues;
    dsDateienDateiBetreff.AfterLoadDFMValues;
    dsDateienKundennummer.AfterLoadDFMValues;
    dsDateienNummerkomplett.AfterLoadDFMValues;
    dsDateienObjektReferenz.AfterLoadDFMValues;
    dsDateienFahrzeugID.AfterLoadDFMValues;
    dsDateienAuslagerungsdatei.AfterLoadDFMValues;
  end;
end;

end.
